/**
 * src/components/hero/HeroMedia.js
 *
 * Columna derecha del hero: mockup del teléfono con badges flotantes.
 * Props: { src, alt, badges: Array<{ icon, text }> }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('HeroMedia', ({ src, alt, badges = [] }) => {
    const badgeEls = badges.map(({ icon, text }, i) =>
        h('div', { className: `hero-media__badge hero-media__badge--${i + 1}` },
            h('span', { className: 'hero-media__badge-icon' }, icon),
            h('span', { className: 'hero-media__badge-text' }, text)
        )
    )

    return h('div', { className: 'hero-media' },
        h('div', { className: 'hero-media__phone' },
            h('img', { src, alt, className: 'hero-media__img' }),
            ...badgeEls
        ),
        h('div', { className: 'hero-media__glow' })
    )
})
